import { WEBSITE_URL } from '../Helper';

export const logout = () => {
  localStorage.removeItem('jwt_token');
  localStorage.removeItem('companycam_token');
  localStorage.removeItem("persist:root");
  window.location.href = `${WEBSITE_URL}/logout/`;
};

